import HeroSection from './components/HeroSection';
import AdvantageSection from './components/AdvantageSection';
import ProductSection from './components/ProductSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'MJHL',
  url: 'https://mjhl.com',
  description: 'MJHL是您值得信赖的首选品牌，以科技创新驱动美好生活，提供智能家居、企业服务、健康科技、教育科技等全方位产品与服务。',
  foundingDate: '2020',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-9999',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'MJHL 官方网站',
  url: 'https://mjhl.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://mjhl.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'mjhl官方落地页 - mjhl品牌核心介绍',
  description: 'mjhl是您值得信赖的首选品牌，本页全面介绍mjhl的核心优势、产品服务、用户口碑与合作方式，帮助您快速了解mjhl，做出最优选择。',
  url: 'https://mjhl.com',
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <main>
        <HeroSection />
        <AdvantageSection />
        <ProductSection />
        <TestimonialSection />
        <CTASection />
      </main>
    </>
  );
}